"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FundList = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var zl_1 = require("../../model/zl");
var service_1 = require("../../../library/base/service");
var FundList = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(FundList, _super);
    function FundList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '基金排行';
        _this.code = '106002';
        _this.desc = '基金排行';
        _this.requestParams = new zl_1.FundListRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return FundList;
}(service_1.BaseService));
exports.FundList = FundList;
//# sourceMappingURL=fundList.js.map